import { getConfig } from '@/config/config.ts';
import { SgwtHelpCenter } from '@sgwt/sgwt-widgets-react';
import type { JSX } from 'react';

export function HelpCenter(): JSX.Element {
  return (
    <SgwtHelpCenter
      applicationId={import.meta.env.VITE_APP_ID}
      mailSubject={getConfig().helpCenter.subject}
    />
  );
}
